import { GET_JOB } from '../../store/jobs/actions/actionTypes';
import {
  GET_TASK,
  // SAVE_TASK,
  GET_FOLDER_DATA,
} from '../../store/tasks/actions/actionTypes';
import { USERS_GET_CURRENT } from '../../store/users/actionTypes';
import { GET_CURRENT_TASK } from '../../store/tasks/getters/getterTypes';
import { GET_QUESTIONS } from '../../store/questions/actions/actionTypes';
import { GET_BUBBLES } from '../../store/bubbles/actions/actionTypes';
import { GET_LOADING_STATE } from '../../store/loading/getters/getterTypes';
import { UNLOAD_CURRENT_TASK } from '../../store/tasks/mutations/mutationTypes';
import { SET_QUESTIONS } from '../../store/questions/mutations/mutationTypes';
import { SET_BUBBLES } from '../../store/bubbles/mutations/mutationTypes';

import { SET_LOADING_STATE } from '../../store/loading/mutations/mutationTypes';

// import TaskDTO from '../../shared/dtos/TaskDTO';

import { GET_CURRENT_USER } from '../../store/users/getters/getterTypes';
import showOfflineDialog from '../../services/offlineDialogManager';
import { WEBSOCKET_EVENT_SUBSCRIBE_TO_ACTION } from '../../store/websocket/actions/actionTypes';

export default {
  async created() {
    this.$store.commit(SET_LOADING_STATE, { value: true });
    this.$store.commit('SET_PROGRESS_BAR', {
      key: 'job-loading',
      value: 0,
      message: 'Loading task...',
    });

    // Somehow this gets called after the task create request is send
    // avoid doing this get then
    if (this.$route.params.taskNumber !== 'create') {
      this.$store.commit('SET_PROGRESS_BAR', {
        key: 'job-loading',
        value: 20,
        message: 'Loading task...',
      });
      await this.$store.dispatch(GET_TASK, this.$route.params.taskNumber);
    }

    this.$store.commit('SET_PROGRESS_BAR', {
      key: 'job-loading',
      value: 40,
      message: 'Loading task details...',
    });
    await this.$store.dispatch(USERS_GET_CURRENT);
    await this.$store.dispatch(GET_JOB, this.$route.params.id);

    this.$store.commit('SET_PROGRESS_BAR', {
      key: 'job-loading',
      value: 60,
      message: 'Loading task content...',
    });

    if (this.currentTask.folderId) {
      await this.$store.dispatch(GET_FOLDER_DATA, this.currentTask.folderId);
    }

    if (this.isInstruction) {
      this.$store.commit('SET_PROGRESS_BAR', {
        key: 'job-loading',
        value: 75,
        message: 'Loading instructions...',
      });
      await this.$store.dispatch(GET_QUESTIONS, this.currentTask._id);
    }

    if (this.isDiagram) {
      this.$store.commit('SET_PROGRESS_BAR', {
        key: 'job-loading',
        value: 75,
        message: 'Loading diagram...',
      });
      await this.$store.dispatch(GET_BUBBLES, this.currentTask._id);
    }

    this.$store.commit(SET_LOADING_STATE, { value: false });

    this.$store.commit('SET_PROGRESS_BAR', {
      key: 'job-loading',
      value: 100,
      message: 'Task loaded',
    });

    setTimeout(() => {
      this.$store.commit('SET_PROGRESS_BAR', {
        key: 'job-loading',
        value: null,
      });
    }, 800);

    this.$store.dispatch(WEBSOCKET_EVENT_SUBSCRIBE_TO_ACTION, {
      action: 'job:on_taken_offline',
      callback: this.jobTakenOffline,
    });
  },
  computed: {
    currentJob() {
      return this.$store.state.JobsModule.currentJob;
    },
    currentTask() {
      return this.$store.getters[GET_CURRENT_TASK];
    },
    currentUser() {
      return this.$store.getters[GET_CURRENT_USER];
    },
    isLoading() {
      return this.$store.getters[GET_LOADING_STATE];
    },
    isDiagram() {
      return this.currentTask ? this.currentTask.taskType === 'diagram' : false;
    },
    isInstruction() {
      return this.currentTask
        ? this.currentTask.taskType === 'instruction'
        : false;
    },
  },
  methods: {
    async jobTakenOffline(data) {
      if (
        this.currentUser &&
        this.currentUser._id !== data.job.checkedOut &&
        this.currentTask &&
        this.currentTask._id &&
        this.currentTask.jobId === data.job._id
      ) {
        showOfflineDialog(this.$router, this.$route, this.$buefy, data.job);
      }
    },
    onSave(updatedTask, onCancelCb) {
      // There is not need anymore to trigger
      // bubbles/question save when the user press save
      // const taskHandlers = {
      //   diagram: () => this.$refs.diagramView.onSave(),
      //   instruction: () => this.$refs.instructionView.onSave(),
      // };

      // const { taskType } = this.currentTask;
      // if (taskHandlers[taskType]) {
      //   taskHandlers[taskType]();
      // } else {
      //   console.warn(`Unsupported task type ${taskType}`);
      // }

      if (this.currentTask.diagram && this.currentTask.diagram.inspections) {
        delete this.currentTask.diagram.inspections;
      }

      // if (updatedTask) {
      //   this.$store.dispatch(SAVE_TASK, new TaskDTO(updatedTask));
      // } else {
      //   this.$store.dispatch(SAVE_TASK, new TaskDTO(this.currentTask));
      // }

      if (onCancelCb) {
        onCancelCb();
      } else {
        try {
          const { id } = this.$route.params;
          const { token, from, package: packageId } = this.$route.query || {};
          if (from === 'wi') {
            return this.$router.push({
              name: 'inspector-work-instructions',
              params: { id, packageId: packageId || undefined },
              query: token ? { token } : undefined,
            });
          }
          if (this.currentTask.folderId) {
            const folderPath = `/folder/${this.currentTask.folderId}`;
            const parentPath = this.$route.path
              .split('/')
              .slice(0, -1)
              .join('/');
            this.$router.push({
              path: parentPath + folderPath,
            });
          } else {
            this.$router.push({
              path: this.$route.path.split('/').slice(0, -1).join('/'),
            });
          }
        } catch (error) {
          console.error('Error navigating back:', error);
          this.$router.back();
        }
      }
    },

    generatePreviousURLForTask(job) {
      let toolUrl;
      if (window.location.href.includes('/editor')) {
        toolUrl = '/view/editor/';
      } else if (window.location.href.includes('/publisher')) {
        toolUrl = '/view/publisher/';
      } else {
        return '/view/dashboard';
      }

      if (window.location.href.includes('token')) {
        const token = window.location.href.split('?token=')[1];
        return `${toolUrl}${job._id}?token=${token}`;
      }
      return toolUrl + job._id;
    },
  },
  beforeDestroy() {
    this.$store.commit(UNLOAD_CURRENT_TASK);
    this.$store.commit(SET_QUESTIONS, []);
    this.$store.commit(SET_BUBBLES, []);
  },
};
